import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IconComponent, OptionComponent} from '@adnova/jf-ng-components';


@Component({
  selector: 'zlng-bankkonto-option',
  standalone: true,
  imports: [
    CommonModule,
    IconComponent,
  ],
  templateUrl: './bankkonto-option.component.html',
  styleUrls: ['./bankkonto-option.component.scss']
})
export class BankkontoOptionComponent extends OptionComponent {

  @Input() bank = '';

  doSelectOption() {
    this.selectedOptionId.emit(this.id);
  }
}
